import '../../css/modules/external_news_item.css';

export class ExternalNewsItem {

  constructor() {

  }

}